module.exports = __webpack_public_path__ + "static/media/liste.ec886869.svg";